import { plural } from './formato';

/**
 * Como o ponto se chama na tela, pelo tipo dele — onda 312 (R12).
 *
 * Nos ensaios de cone e de dilatômetro (CPT, CPTu, SCPTu, DMT, SDMT) o que
 * se executa é uma VERTICAL: o cone é cravado, não se perfura nada. Nas
 * sondagens (SPT, trado, rotativa, mista), um FURO. O resto (Vane,
 * permeabilidade, placa, poço, instrumento) é PONTO. Os títulos que juntam
 * todos os tipos dizem «Furos, verticais e pontos»; o campo «Furo/ponto» da
 * amostra, o mapa do acervo SPT e os PDFs de laboratório não mudam.
 *
 * Mora num módulo neutro (revisão final da 312): a OS no Campo
 * (`telas/OsCampo.tsx`) e o diário (`telas/Diarios.tsx`) usam os dois
 * ajudantes, e o OsCampo já importa o formulário do diário — morando no
 * OsCampo, eles fechavam um ciclo de importação entre as duas telas.
 */
export function nomeDoPonto(tipo: string | null | undefined): 'vertical' | 'furo' | 'ponto' {
  if (['cpt', 'cptu', 'scptu', 'dmt', 'sdmt'].includes(tipo ?? '')) return 'vertical';
  if (['spt', 'trado', 'rotativa', 'mista'].includes(tipo ?? '')) return 'furo';
  return 'ponto';
}

/** «3 furos · 10 verticais» — os pontos contados pelo nome de cada tipo (R12). */
export function contarPontos(tipos: (string | null | undefined)[]): string {
  const n = { furo: 0, vertical: 0, ponto: 0 };
  for (const t of tipos) n[nomeDoPonto(t)] += 1;
  return [
    n.furo ? plural(n.furo, 'furo', 'furos') : null,
    n.vertical ? plural(n.vertical, 'vertical', 'verticais') : null,
    n.ponto ? plural(n.ponto, 'ponto', 'pontos') : null,
  ].filter(Boolean).join(' · ');
}
